import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';

import c from '../utils/constants';
import { CreateDataPayload } from './useCreateData';

export interface Payload extends CreateDataPayload {
  id: string;
}

export default function useUpdateData() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useMutation({
    mutationFn: async (payload: Payload) => {
      const api = new Api(args);

      const data = await api.patch(
        await withAcl({
          account: {
            url: `/api/v3/data/${payload.id}`,
            payload,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/data/${payload.id}`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [c.FIELDS] });
    },
  });
}
